import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import PublishIcon from '@material-ui/icons/Publish';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import CancelPopUp from './ConfirmationPopUps/CancelPopUp';
import useStyles from './styles';
import InvoiceDetails from './InvoiceDetails/InvoiceDetails';
import ImportInvoiceFromExcelPopUp from './ImportPopup/ImportInvoiceFromExcelPopUp';
import SuccessUpdateAlert from '../TicketDetails/SuccessUpdateAlert';
import ApiService from '../../services/ApiService';
import SaveInvoicesFailedPopUp from './SaveInvoicesFailedPopUp';

export default function AddInvoicePage() {
  const [openCancelAddingInvoicePopUp, setOpenCancelAddingInvoicePopUp] =
    React.useState(false);
  const [supplier, setSupplier] = React.useState('');
  const [activityType, setActivityType] = React.useState('');
  const [invoiceNumber, setInvoiceNumber] = React.useState('');
  const [invoiceDate, setInvoiceDate] = React.useState(new Date());
  const [purchaseOrder, setPurchaseOrder] = React.useState('');

  const [openImportInvoicePopUp, setOpenImportInvoicePopUp] =
    React.useState(false);
  const [validationErrorSupplier, setValidationErrorSupplier] =
    React.useState(null);

  const [validationErrorInvoiceNumber, setValidationErrorInvoiceNumber] =
    React.useState(null);
  const [invoiceSaveMessage, setInvoiceSavedMessage] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const [cancel, setCancel] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState([]);
  const [displaySuccessPopup, setDisplaySuccessPopup] = React.useState(false);
  const [openSaveInvoicesFailedPopUp, setOpenSaveInvoicesFailedPopUp] =
    React.useState(false);
  const [saveInvoicesError, setSaveInvoicesError] = React.useState(null);

  const initialInvoice = {
    manualInput: true,
    eventDate: new Date(),
    wagonNumber: '',
    activityType: '',
    amount: 0,
    maintenanceTicketInvoiceList: [
      {
        ticketNumber: '',
      },
    ],
  };
  const [invoices, setInvoices] = React.useState([initialInvoice]);
  const [attachment, setAttachment] = React.useState({});

  const classes = useStyles();
  const { t } = useTranslation();

  const dateFormatter = (date) => {
    const isValidDate = Date.parse(date);
    if (Number.isNaN(isValidDate)) {
      return null;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split('T')[0];
  };
  function importInvoice() {
    setOpenImportInvoicePopUp(true);
  }
  function closePopUp() {
    setOpenImportInvoicePopUp(false);
  }

  function initialiseInvoices() {
    setSupplier('');
    setInvoiceNumber('');
    setInvoiceDate(new Date());
    setInvoices([initialInvoice]);
    setActivityType('');
    setPurchaseOrder('');
  }

  function confirmCancel() {
    setOpenCancelAddingInvoicePopUp(false);
    initialiseInvoices();
    setValidationErrorInvoiceNumber(null);
    setCancel(true);
  }

  function cancelOver() {
    setCancel(false);
  }

  function getValidationErrors(errors) {
    if (errors.invoiceNumber) {
      setValidationErrorInvoiceNumber(t(errors.invoiceNumber));
    }

    if (errors.supplier) {
      setValidationErrorSupplier(t(errors.supplier));
    }
  }

  function hasActivityTypeError(activity) {
    if (activity === null || activity === undefined) return true;
    if (
      activity !== 'cleaning' &&
      activity !== 'transport' &&
      activity !== 'repair' &&
      activity !== 'others'
    )
      return true;
    return false;
  }

  function getInvoicesFromExcel(invoicesFromExcel) {
    const invoicesFormatted = invoicesFromExcel.map((invoice) => {
      const numberOfTicket = invoice.maintenanceTicketInvoiceList.length;
      const ticketsWithSelectedField = invoice.maintenanceTicketInvoiceList.map(
        (ticket) => {
          return { ...ticket, selected: numberOfTicket === 1 };
        },
      );
      return {
        ...invoice,
        maintenanceTicketInvoiceList: ticketsWithSelectedField,
        manualInput: false,
      };
    });
    setInvoices(invoicesFormatted);
  }

  function createFormData(invoicesToBeSaved) {
    const data = new FormData();
    data.append(
      'invoices',
      new Blob([JSON.stringify(invoicesToBeSaved)], {
        type: 'application/json',
      }),
    );
    data.append('file', attachment);
    return data;
  }
  function save() {
    if (invoices.length > 0) {
      setLoading(true);
      const invoicesToBeSaved = [];
      const invalidActivityTypeErrors = [];
      let isInvalidActivityType = false;
      let isTicketNotSelected = false;
      const ticketSelectionErrors = [];
      invoices.forEach((invoice) => {
        const newInvoice = {
          supplier,
          activityType: invoice.activityType,
          invoiceNumber,
          invoiceDate,
          eventDate:
            typeof invoice.eventDate === 'string' ||
            invoice.eventDate instanceof String
              ? invoice.eventDate
              : dateFormatter(invoice.eventDate),
          wagonNumber: invoice.wagonNumber,
          amount: invoice.amount,
          purchaseOrder,
        };

        let ticketSelected = false;
        invoice.maintenanceTicketInvoiceList.forEach((ticket) => {
          if (ticket.ticketNumber === '') {
            ticketSelected = true;
          } else if (ticket.ticketNumber !== '' && ticket.selected) {
            newInvoice.maintenanceTicketNumber = ticket.ticketNumber;
            ticketSelected = true;
          }
        });

        if (
          invoice.maintenanceTicketInvoiceList?.length >= 1 &&
          !ticketSelected
        ) {
          isTicketNotSelected = true;
          ticketSelectionErrors.push({ tktSelected: false });
        } else {
          invoicesToBeSaved.push(newInvoice);
          ticketSelectionErrors.push({});
        }

        if (hasActivityTypeError(invoice.activityType)) {
          isInvalidActivityType = true;
          invalidActivityTypeErrors.push({ activityType: false });
        } else invalidActivityTypeErrors.push({ activityType: true });
      });

      if (isInvalidActivityType) {
        // show error popup
        setLoading(false);
        setValidationErrors(invalidActivityTypeErrors);
        setSaveInvoicesError('Select Activity Type for each wagon');
        setOpenSaveInvoicesFailedPopUp(true);
      } else if (isTicketNotSelected) {
        // show alert
        setLoading(false);
        setValidationErrors(ticketSelectionErrors);
        setSaveInvoicesError('Select ticket for the wagon');
        setOpenSaveInvoicesFailedPopUp(true);
      } else {
        const invoicesWithFile = createFormData(invoicesToBeSaved);
        ApiService.saveInvoices(invoicesWithFile)
          .then(() => {
            setLoading(false);
            initialiseInvoices();
            setDisplaySuccessPopup(true);
            setInvoiceSavedMessage(
              `Invoice number ${invoiceNumber}  added successfully `,
            );
          })
          .catch((error) => {
            setLoading(false);
            if (error) {
              setValidationErrors(error);
              if (error[0].supplier) {
                setValidationErrorSupplier(error[0].supplier);
              }
              if (error[0].invoiceNumber) {
                setValidationErrorInvoiceNumber(error[0].invoiceNumber);
              }
            }
          });
      }
    }
  }
  function getFile(file) {
    setAttachment(file);
  }
  function getAllInvoices(allInvoices) {
    setInvoices(allInvoices);
  }
  function closeSuccessPopUp() {
    setDisplaySuccessPopup(false);
  }

  function closeSaveInvoicesFailedPopUp() {
    setSaveInvoicesError(null);
    setOpenSaveInvoicesFailedPopUp(false);
  }

  return (
    <div className={classes.root}>
      <IconButton
        aria-label="cancel"
        className={classes.cancelButton}
        onClick={() => setOpenCancelAddingInvoicePopUp(true)}
      >
        <CloseIcon />
      </IconButton>{' '}
      <IconButton
        data-testid="save"
        aria-label="save"
        className={classes.saveButton}
        onClick={save}
      >
        <CheckIcon />
      </IconButton>{' '}
      <Grid container spacing={0}>
        <Typography className={classes.title}>
          {' '}
          {t('add an invoice')}
        </Typography>
        <Paper elevation={0} className={classes.contentPaper}>
          <div className={classes.description}>{t('invoice description')}</div>
          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid container item xs={10}>
              <Grid item xs={2}>
                <FormLabel className={classes.formLabel}>
                  {t('Supplier')}
                  <span className={classes.asterisk}> *</span>
                </FormLabel>
              </Grid>
              <Grid item xs={3} container justify="center">
                <FormLabel
                  className={`${classes.formLabel} ${classes.activityTypeMargin}`}
                >
                  {t('Activity type')}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <FormLabel className={classes.formLabel}>
                  {t('Invoice number')}
                  <span className={classes.asterisk}> *</span>
                </FormLabel>
              </Grid>
              <Grid item xs={3} container justify="center">
                <FormLabel
                  className={`${classes.formLabel} ${classes.invoiceDateMargin}`}
                >
                  {t('Invoice date')}
                  <span className={classes.asterisk}> *</span>
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <FormLabel className={classes.formLabel}>
                  {t('Purchase order')}
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <TextField
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value={supplier}
                  onChange={(e) => {
                    setValidationErrorSupplier(null);
                    setSupplier(e.target.value);
                  }}
                  error={validationErrorSupplier !== null}
                  helperText={validationErrorSupplier}
                  FormHelperTextProps={{ className: classes.helperText }}
                />
              </Grid>
              <Grid item xs={3} container justify="center">
                <FormControl className={classes.formControl}>
                  <Select
                    variant="outlined"
                    displayEmpty
                    className={classes.select}
                    inputProps={{
                      'aria-label': 'Without label',
                      'data-testid': 'select-activity-type',
                    }}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    value={activityType}
                    onChange={(e) => {
                      setActivityType(e.target.value);
                    }}
                  >
                    <MenuItem value="" disabled>
                      {t('Select an activity type')}
                    </MenuItem>
                    <MenuItem value="cleaning"> {t('Cleaning')}</MenuItem>
                    <MenuItem value="transport">{t('Transport')}</MenuItem>
                    <MenuItem value="repair">{t('Repair')}</MenuItem>
                    <MenuItem value="others"> {t('others')}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2}>
                <TextField
                  inputProps={{
                    'data-testid': 'input-invoice-number',
                  }}
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value={invoiceNumber}
                  onChange={(e) => {
                    setValidationErrorInvoiceNumber(null);
                    setInvoiceNumber(e.target.value);
                  }}
                  error={validationErrorInvoiceNumber !== null}
                  helperText={validationErrorInvoiceNumber}
                  FormHelperTextProps={{ className: classes.helperText }}
                />
              </Grid>
              <Grid item xs={3} container justify="center">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className={classes.datePicker}
                    InputProps={{
                      className: classes.input,
                    }}
                    disableToolbar
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    value={invoiceDate || new Date()}
                    onChange={(date) => {
                      setInvoiceDate(date);
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={2}>
                <TextField
                  data-testid="purchase-order"
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  value={purchaseOrder}
                  onChange={(e) => {
                    setPurchaseOrder(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item xs={2}>
              <Button
                variant="contained"
                className={classes.importButton}
                startIcon={<PublishIcon />}
                onClick={importInvoice}
              >
                {t('import invoice')}
              </Button>
            </Grid>
          </Grid>
          <ImportInvoiceFromExcelPopUp
            openImportInvoiceFromExcelPopUp={openImportInvoicePopUp}
            sendValidationErrors={getValidationErrors}
            supplier={supplier}
            activityType={activityType}
            invoiceNumber={invoiceNumber}
            invoiceDate={invoiceDate}
            closeImportInvoicePopUp={closePopUp}
            setInvoicesFromExcel={getInvoicesFromExcel}
            sendFile={getFile}
          />
        </Paper>
        {loading && (
          <Paper
            elevation={0}
            position="absolute"
            zindex="2"
            data-testid="loader"
          >
            <CircularProgress className={classes.loader} />
          </Paper>
        )}
        <InvoiceDetails
          defaultInvoices={invoices}
          activityType={activityType}
          isCancelling={cancel}
          cancelOver={cancelOver}
          saveValidationErrors={validationErrors}
          sendAllInvoices={getAllInvoices}
        />
      </Grid>
      <CancelPopUp
        editMode={false}
        openCancelPopUp={openCancelAddingInvoicePopUp}
        confirmCancel={confirmCancel}
        closeCancelPopUp={() => setOpenCancelAddingInvoicePopUp(false)}
      />
      <SuccessUpdateAlert
        successPopup={displaySuccessPopup}
        successMessage={invoiceSaveMessage}
        handleCloseSuccessUpdateAlert={closeSuccessPopUp}
      />
      <SaveInvoicesFailedPopUp
        openSaveInvoicesFailedPopUp={openSaveInvoicesFailedPopUp}
        closeSaveInvoicesFailedPopUp={closeSaveInvoicesFailedPopUp}
        errorMessage={saveInvoicesError}
      />
    </div>
  );
}
